import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import {
  UPDATE_APPLE_PAY_AVAILABLE,
  UPDATE_GOOGLE_PAY_AVAILABLE,
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE,
  DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER,
  HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN,
  DISMISS_BETA_TRIP_BANNER,
  SET_OPTIMIZELY_EXPERIMENT,
  SET_OPTIMIZELY_FEATURE_FLAG,
  SET_LAB_FEATURE_FLAGS,
  SET_HEADLESS_MODE
} from 'actions/actionConstants'
import {
  FETCH_MERCHANT_FEE_CONFIG,
  FETCH_PAYTO_SUPPORTED_BANKS,
  FETCH_DEPOSIT_CONFIG,
  FETCH_PAYPAL_SETTINGS,
  FETCH_LAB_FEATURE_FLAG_DECISIONS,
} from 'actions/apiActionConstants'

export const initialFeaturesState: App.FeaturesState = {
  context: undefined,
  experiments: {},
  flags: {},
  labFlags: {},
}

export const initialSystemState: App.SystemState = {
  appBannerCookie: false,
  customerPortalURL: '',
  originalCanonicalURL: '',
  headlessMode: false,
  canPayWithApplePay: false,
  canPayWithGooglePay: false,
  storeMode: false,
  referrer: '',
  device: {
    osName: '',
    browserName: '',
    deviceType: 'other',
  },
  rawUserAgentString: '',
  previewMode: false,
  merchantFeeConfigs: [],
  payToSupportedBanks: [],
  depositConfigs: undefined,
  payPalSettings: undefined,
  showMarginInSpoofMode: false,
  luxPlusFreePreviewBannerDismissed: false,
  hotelCancellationPriceChangeModalSeen: false,
  betaTripBannerDismissed: false,
  features: {
    ...initialFeaturesState,
  },
}

const apiCalls = apiReducerSwitch<App.SystemState>({
  [FETCH_MERCHANT_FEE_CONFIG]: {
    request: () => ({
      merchantFeeConfigs: [],
    }),
    success: (_state, action) => ({
      merchantFeeConfigs: action.data,
    }),
  },
  [FETCH_PAYTO_SUPPORTED_BANKS]: {
    request: () => ({
      payToSupportedBanks: [],
    }),
    success: (_state, action) => ({
      payToSupportedBanks: action.data,
    }),
  },
  [FETCH_DEPOSIT_CONFIG]: {
    request: () => ({
      depositConfigs: undefined,
    }),
    success: (_state, action) => ({
      depositConfigs: action.data,
    }),
  },
  [FETCH_PAYPAL_SETTINGS]: {
    request: () => ({
      payPalSettings: undefined,
    }),
    success: (_state, action) => ({
      payPalSettings: action.data,
    }),
  },
  [FETCH_LAB_FEATURE_FLAG_DECISIONS]: {
    request: () => ({
      features: {
        ...initialFeaturesState,
      },
    }),
    success: (state, action) => ({
      features: {
        ...state.features,
        labFlags: {
          ...state.features.labFlags,
          ...action.data,
        },
      },
    }),
  },
})

export default createAppReducer<App.SystemState>(initialSystemState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [UPDATE_APPLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithApplePay: action.value,
  }),
  [UPDATE_GOOGLE_PAY_AVAILABLE]: (_state, action) => ({
    canPayWithGooglePay: action.value,
  }),
  [TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE]: (state, action) => ({
    ...state,
    showMarginInSpoofMode: action.showMarginInSpoofMode,
  }),
  [DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER]: (state) => ({
    ...state,
    luxPlusFreePreviewBannerDismissed: true,
  }),
  [HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN]: (state) => ({
    ...state,
    hotelCancellationPriceChangeModalSeen: true,
  }),
  [DISMISS_BETA_TRIP_BANNER]: (state) => ({
    ...state,
    betaTripBannerDismissed: true,
  }),
  // Feature Flags
  [SET_OPTIMIZELY_EXPERIMENT]: (state, action) => ({
    ...state,
    features: {
      ...state.features,
      experiments: {
        ...state.features.experiments,
        [action.flagKey]: {
          ...state.features.experiments[action.flagKey],
          ...action.value,
        },
      },
    },
  }),
  [SET_OPTIMIZELY_FEATURE_FLAG]: (state, action) => ({
    ...state,
    features: {
      ...state.features,
      flags: {
        ...state.features.flags,
        [action.flagKey]: action.value,
      },
      [action.flagKey]: action.value,
    },
  }),
  [SET_LAB_FEATURE_FLAGS]: (state, action) => ({
    ...state,
    features: {
      ...state.features,
      labFlags: action.labFlags,
    },
  }),
  [SET_HEADLESS_MODE]: (state, action) => ({
    ...state,
    headlessMode: action.headlessMode,
  }),
})
